import { ENVIRONMENT } from "@helper/getEnvVariables";

export const FOLLOW_TOPIC_TOAST_MESSAGE_COPY = "Topic followed successfully";
export const MYBH_LINK = "/mybh";
export const MANAGE_TOPICS_LINK = "/manage/topics";

export const ENABLE_MYBH = import.meta.env.VITE_ENABLE_MYBH === "1";

export const PUBLICATION = "bh";
export const BAAS_CLIENT_ENV = ENVIRONMENT;
